import { ADMIN_SIDEBAR } from './adminSidebar'

// Senior Accountant 2 — full admin access (read + write) EXCEPT the Attendance and
// Settings sections. Derive from the admin sidebar and strip only those two
// sections so it never drifts from admin. Route access is enforced separately: the
// role is admin-equivalent in access.js ROLE_GROUPS, /settings is blocked by
// requiresPermission: 'manage_settings', and the attendance routes are blocked by
// requiresPermission: 'view_attendance' — two keys this role's permission map
// deliberately omits (see server/config/permissions.php).
export const SENIOR_ACCOUNTANT_2_SIDEBAR = ADMIN_SIDEBAR.filter((item) => {
  const isSettingsTitle = item.slug === 'title' && item.name === 'Settings'
  const isSettingsLink = item.slug === 'link' && item.href === '/settings'
  const isAttendanceTitle = item.slug === 'title' && item.name === 'Attendance'
  const isAttendanceDropdown = item.slug === 'dropdown' && item.name === 'Attendance'
  return !isSettingsTitle && !isSettingsLink && !isAttendanceTitle && !isAttendanceDropdown
})
